// extracted by mini-css-extract-plugin
var _1 = "CommentThreadFull-module__commentThreadFull--s9tZ0";
var _2 = "CommentThreadFull-module__create--RVJx3";
var _3 = "CommentThreadFull-module__expanded--OGdik";
var _4 = "CommentThreadFull-module__hasMoreScrollContent--Ig5ua";
export { _1 as "commentThreadFull", _2 as "create", _3 as "expanded", _4 as "hasMoreScrollContent" }
